import React from 'react';
import { BackNavigation } from '../components/shared';
import { AppPage } from '../layouts/types';

const About: AppPage = () => {
  const image = '/img/ViliyoLogoBig.svg';

  return (
    <div className="mb-8 px-4 tablet:px-6 laptop:px-8 desktop:px-10">
      <BackNavigation title="About Viliyo" />

      {/* Header Section (ALWAYS 2 COL) */}
      <div className="bg-app-blue text-white rounded-xl mt-4 p-6 tablet:p-8 laptop:p-10">
        <div className="mobile:grid-cols-1 tablet:grid-cols-1 grid grid-cols-2 gap-8 items-center">
          
          {/* Logo */}
          <div className="flex justify-center laptop:justify-start">
            <img
              alt="ViliyoLogo"
              src={image}
              className="w-[160px] tablet:w-[200px] laptop:w-[260px]"
            />
          </div>

          {/* Text */}
          <div className="text-[13px] tablet:text-[14px] leading-relaxed space-y-3">
            <p>
              When live training moved online, trainers were forced to rely on tools
              that were never designed for learning delivery.
            </p>

            <p>
              <b>Viliyo</b> is a training-first platform designed around structure,
              flow, and presence. It brings facilitation, interaction, and program
              management into a single system so trainers can focus on delivering
              learning — not managing tools.
            </p>

            <p className="font-semibold">
              This is not a meeting platform with training features added later.
            </p>

            <p>
              It is a system engineered specifically for live training, from the
              ground up.
            </p>
          </div>
        </div>
      </div>

      {/* Content Section (Responsive) */}
      <div className="mt-12 grid mobile:grid-cols-1 tablet:grid-cols-1 laptop:grid-cols-2 desktop:grid-cols-2 largescreen:grid-cols-2 xxl:grid-cols-2 gap-10 max-w-[1200px] mx-auto">
        
        {/* What We Believe */}
        <div className="bg-white rounded-xl shadow-sm p-6">
          <h2 className="text-xl font-bold text-app-blue mb-4">
            What We Believe
          </h2>

          <ul className="text-[14px] text-gray-700 space-y-3 list-disc pl-5">
            <li>Training is not a meeting</li>
            <li>Structure enables better learning, not rigidity</li>
            <li>Interaction should be intentional, not improvised</li>
            <li>Trainers deserve systems that support how they work</li>
            <li>Outcomes matter more than attendance</li>
          </ul>

          <p className="text-[13px] text-gray-500 mt-6">
            These beliefs guide how every part of Viliyo is designed.
          </p>
        </div>

        {/* Who We Are */}
        <div className="bg-white rounded-xl shadow-sm p-6">
          <h2 className="text-xl font-bold text-app-blue mb-4">
            Who We Are
          </h2>

          <div className="text-[14px] text-gray-700 space-y-4 leading-relaxed">
            <p>
              Viliyo is built by a team that has worked closely with trainers,
              facilitators, and organizations delivering live training at scale.
            </p>

            <p>
              We’ve seen firsthand how great training breaks down — not because
              of content or intent, but because of tools that weren’t built for
              the realities of live facilitation.
            </p>

            <p>
              Our focus is on designing a platform that feels calm, intentional,
              and dependable in the middle of live delivery.
            </p>

            <p className="font-semibold mt-4">We care deeply about:</p>

            <ul className="list-disc pl-5 space-y-2">
              <li>How sessions flow in real time</li>
              <li>How trainers stay in control without distraction</li>
              <li>How learning programs scale without losing quality</li>
            </ul>

            <p className="mt-4 font-medium text-app-blue">
              Viliyo is the result of that focus.
            </p>
          </div>
        </div>

      </div>
    </div>
  );
};

export default About;